const errors = {
    "CONN_ERROR" : "FETCH_ERROR",
    "PARSING_ERROR" : "PARSING_ERROR"
}

export {
    errors
}